export const OfficeAccessoriesLiveUpdateState = {
	url: '/accessories/update-live/:bu_id/:prod_id',
	title: 'Office Live Accessories - Update',
	template: '<office-accessories-update-page></office-accessories-update-page>',
	params: {
		prod_id: null,
		bu_id: null,
	},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeAccessoriesLiveUpdatePageMod" */
			'@Containers/office-accessories-page/live-update/live-update.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
